module.exports = __webpack_public_path__ + "media/images/icons/resources-black-0e7930d480351287b7d552066881b660.svg";